export enum PolicyKey {
  BankAccountAgreement = 'bank_account_agreement',
  DirectNewAccountForm = 'direct_new_account_form',
  EntityCorporationCashAccountAgreementForm = 'entity_corporation_cash_account_agreement_form',
  EntityDueDiligenceForm = 'entity_due_diligence_form',
  EntityLLCAgreementForm = 'entity_llc_agreement_form',
  EntityNewAccountRIAForm = 'entity_new_account_ria_form',
  InvestmentManagementAgreement = 'investment_management_agreement',
}
